import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { setupFunnelStorageSync } from './services/funnel-cleanup.service'
import './styles/index.css'

import * as Sentry from "@sentry/react";

setupFunnelStorageSync();

Sentry.init({
  dsn: "https://f32bb4d8f77faf4be0f933cb3894a109@o4511868843982848.ingest.de.sentry.io/4511868917383248",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element not found')

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
